"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusToJSON = exports.StatusFromJSONTyped = exports.StatusFromJSON = exports.Status = void 0;
/**
 * The current status of an asset throughout lifecycle processes.
 * @export
 */
exports.Status = {
    Error: 'ERROR',
    Processing: 'PROCESSING',
    Ready: 'READY',
    WaitingUpload: 'WAITING_UPLOAD'
};
function StatusFromJSON(json) {
    return StatusFromJSONTyped(json, false);
}
exports.StatusFromJSON = StatusFromJSON;
function StatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.StatusFromJSONTyped = StatusFromJSONTyped;
function StatusToJSON(value) {
    return value;
}
exports.StatusToJSON = StatusToJSON;
